import React from 'react'
import CadUsefulDataContainer from 'modules/cadUsefulData/container'
import LoadingBlockWrapper from "components/LoadingBlockWrapper"
import CadUsefulDataContext from "./context"

export default function CadUsefulDataProvider({ children }) {
	const href = window.location.href
	const isCadPage = href.includes('/cad/')

	// Si on n'est pas sur une page CAD, on ne charge pas les données
	if (!isCadPage) {
		return (
			<CadUsefulDataContext.Provider value={{}}>
				{children}
			</CadUsefulDataContext.Provider>
		)
	}

	return (
		<CadUsefulDataContainer>
			{({ isPending: isPendingCadUsefulData, data: cadUsefulData }) => {
				// S'assurer que les données ne sont jamais undefined, au minimum un objet vide
				const safeData = cadUsefulData || {}
				
				return (
					<CadUsefulDataContext.Provider value={safeData}>
						{isPendingCadUsefulData ? <LoadingBlockWrapper show /> : children}
					</CadUsefulDataContext.Provider>
				)
			}}
		</CadUsefulDataContainer>
	)
}
